import React from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import Layout from '../../../containers/Layout';
import Sidebar from '../../../components/AddOrEditPage/Sidebar';
import Servicer from '../../../components/AddOrEditPage/Admin/AddOrEditServicer/Sections/Servicer';
import Contacts from '../../../components/AddOrEditPage/Admin/AddOrEditServicer/Sections/Contacts';

import ServicerService from '../../../services/ServicerService';
import useAddQueryParam from '../../../hooks/useAddQueryParams';

const sections = [
  {
    title: 'Servicer',
    svgPath: (
      <>
        <path d="M10.59 7.658 8 5.5 5.41 7.658A.25.25 0 0 1 5 7.466V0h6v7.466a.25.25 0 0 1-.41.192Z" />
        <path d="M14 16H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2v2H2v12h12V2h-2V0h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Z" />
      </>
    ),
  },
  {
    title: 'Contacts',
    svgPath: (
      <path d="M12.311 9.527c-1.161-.393-1.85-.825-2.143-1.175A3.991 3.991 0 0012 5V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1c0 1.406.732 2.639 1.832 3.352-.292.35-.981.782-2.142 1.175A3.942 3.942 0 001 13.26V16h14v-2.74c0-1.69-1.081-3.19-2.689-3.733zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1c0 1.103-.897 2-2 2s-2-.897-2-2V4zm7 10H3v-.74c0-.831.534-1.569 1.33-1.838 1.845-.624 3-1.436 3.452-2.422h.436c.452.986 1.607 1.798 3.453 2.422A1.943 1.943 0 0113 13.26V14z" />
    ),
  },
];

export default function AddOrEditServicerPage() {
  const { id } = useParams();

  const { data: servicer } = useQuery({
    queryKey: ['servicer', id],
    queryFn: () => ServicerService.getServicer(id),
    enabled: !!id,
  });

  const { currentQueryParam } = useAddQueryParam('tab');

  return (
    <Layout>
      <div className="w-full max-w-9xl mx-auto h-full md:h-[calc(100dvh-64px)] overflow-hidden relative">
        <div className="sm:flex sm:justify-between sm:items-center mb-5 h-full">
          <div className="mb-4 sm:mb-0 w-screen md:w-full h-full relative">
            <div className="md:h-16 relative z-30">
              <h1 className="px-4 sm:px-6 text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold bg-slate-100 dark:bg-slate-900 pt-6 z-20 after:absolute after:-top-1 after:h-2 after:w-full after:left-0 after:bg-slate-100 after:dark:bg-slate-900">
                {id ? 'Edit Servicer' : 'Add Servicer'}
              </h1>
            </div>
            <div className="px-4 sm:px-6  flex md:flex-row flex-col h-full md:h-[calc(100%-64px)]">
              <Sidebar
                isEdit={!!id}
                sections={sections}
                url={`/admin/servicers/${id}`}
              />
              <div className="md:ml-6 2xl:mx-6 md:pt-8 flex-1 overflow-auto">
                {currentQueryParam === 'Servicer' && (
                  <Servicer
                    id={id}
                    servicer={servicer}
                    url={`/admin/servicers/${id}`}
                  />
                )}
                {currentQueryParam === 'Contacts' && <Contacts id={id} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
